import './styles.scss';
import mask from 'images/mission-mask.svg';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useRef } from 'react';

gsap.registerPlugin(ScrollTrigger);

const markers = false;
const ease = 'power1.in';

const MissionAndValuesSection = ({ background = '', title = '', data = [], loading }) => {
    const maskStyle = { maskImage: `url('${mask}')`, WebkitMaskImage: `url('${mask}')` };
    const container = useRef();

    useGSAP(
        () => {
            gsap.from('.mission-section__title', {
                y: 10,
                opacity: 0,
                ease: ease,
                duration: 0.4,
                scrollTrigger: {
                    trigger: '.mission-section',
                    start: 'top 70%',
                    markers: markers,
                },
            });
            gsap.from('.mission-section__mask', {
                y: 10,
                opacity: 0,
                ease: ease,
                duration: 0.4,
                scrollTrigger: {
                    trigger: '.mission-section',
                    start: 'top 50%',
                    markers: markers,
                },
            });
        },
        { dependencies: [loading, data], scope: container, revertOnUpdate: true },
    );

    useGSAP(
        () => {
            if (data.length) {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: '.mission-section',
                        start: 'top 8px',
                        // end: '+=100%',
                        end: `+=${data.length * 35}%`,
                        scrub: 1,
                        markers: markers,
                        pin: true,
                    },
                });
                // tl.from('.mission-section__title', { opacity: 0, y: 50 })
                tl.fromTo('.mission-section__mask', { maskSize: 30 }, { maskSize: 100 })
                    .to('.mission-section__title', { opacity: 0 }, 0)
                    .fromTo('.values-card-wrapper', { yPercent: data.length * 135 }, { yPercent: 0, stagger: 0.1 })
                    // .fromTo('.values-section', { yPercent: 0 }, { yPercent: -50 });
                    .fromTo('.values-section', { yPercent: 0 }, { yPercent: -data.length * 16.5 });
            }
        },
        { dependencies: [loading, data], scope: container },
    );

    return (
        <section className="mission-values-section container" ref={container}>
            <div className="mission-section">
                <div className="mission-section__gradient" />
                <div className="mission-section__mask" style={maskStyle}>
                    <img src={background} alt="background" />
                </div>
                <div className="mission-section__title">{title}</div>
                <div className="values-section" style={{ height: `${data.length * 33.3}%` }}>
                    {data?.map((card, index) => (
                        <div className="values-card-wrapper" key={index}>
                            <div className="angle-decor" />
                            <div className="values-card">
                                <div className="gradient-number light">
                                    <span>{index + 1}</span>
                                </div>
                                {card.title && <div className="values-card__title">{card.title}</div>}
                                {card.text && <div className="values-card__text">{card.text}</div>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MissionAndValuesSection;
